import ReactGA from "react-ga4";

export const initGA = () => {
  if (!process.env.REACT_APP_GA_ID) return;
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
};

export const trackPageView = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

export const trackEvent = (category, action, label = "") => {
  ReactGA.event({
    category,
    action,
    label,
  });
};